let timelineElements = [
  {
    id: 1,
    title: "Purdue University",
    location: "Computer Information Technology",
    description: "",
    buttonText: "GPA: 3.90/4.0",
    date: "Sept 2021 - Jan 2024",
    icon: "school",
  },
  {
    id: 2,
    title: "Software Engineer Intern",
    location: "LetsRent LLC (Startup)",
    description: "",
    buttonText: "TalentVoice",
    date: "May 2023 - Aug 2023",
    icon: "work",
  },
  {
    id: 3,
    title: "Software Engineer Intern",
    location: "Tensorchord (Startup)",
    description: "",
    buttonText: "Envd - MLOps",
    date: "Dec 2022 - Mar 2023",
    icon: "work",
  },
  {
    id: 4,
    title: "Research Assistant",
    location: "Reliable and Secure System Laboratory",
    description: "",
    buttonText: "Under Review",
    date: "May 2022 - Dec 2022",
    icon: "work",
  },
  {
    id: 5,
    title: "Research Assistant",
    location: "Network and Embedded System Laboratory",
    description: "",
    buttonText: "IOTDI 2021",
    date: "May 2020 - Sept 2020",
    icon: "work",
  },
  {
    id: 6,
    title: "University of California, Los Angeles (UCLA)",
    location: "Computer Science",
    description: "",
    buttonText: "GPA: 3.83/4.0",
    date: "September 2019 - May 2021",
    icon: "school",

  },
  {
    id: 7,
    title: "Shanghai Jiao Tong University",
    location: "Bachelor Degree in Computer Science",
    description: "",
    buttonText: "GPA: 3.91/4.0",
    date: "September 2015 - May 2019",
    icon: "school",
  },

];

export default timelineElements;